/**
 * The requirement-set lifecycle, mirroring RequirementSetStatuses.EnumValue. The generated client
 * carries the status as its numeric EnumValue plus a display name, so the screen maps it once here
 * rather than comparing names.
 */
export enum RequirementSetStatus {
  Draft = 0,
  Review = 1,
  Active = 2,
  Archived = 3,
}

export const statusOf = (statusEnumValue?: number): RequirementSetStatus =>
  (statusEnumValue ?? RequirementSetStatus.Draft) as RequirementSetStatus;

/** Only a Draft is editable — an approved set is superseded by a new version, never amended. */
export const isEditableStatus = (status: RequirementSetStatus) =>
  status === RequirementSetStatus.Draft;

export const statusChipColor = (status: RequirementSetStatus) => {
  switch (status) {
    case RequirementSetStatus.Review:
      return "warning" as const;
    case RequirementSetStatus.Active:
      return "success" as const;
    case RequirementSetStatus.Archived:
      return "error" as const;
    default:
      return "default" as const;
  }
};
